export default "__VITE_ASSET__BA92i6Oh__"